import Cookies from 'js-cookie'

const TokenKey: string = 'Authorization'

export function getToken(): string | undefined {
  return Cookies.get(TokenKey)
}

export function getRefreshToken(): string | undefined {
  return Cookies.get('refresh_token')
}

export function setToken(token: string): void {
  Cookies.set(TokenKey, token)
}

export function setRefreshToken(token: string): void {
  Cookies.set('refresh_token', token)
}

export function removeToken(): void {
  Cookies.remove(TokenKey)
}

export function removeRefreshToken(): void {
  Cookies.remove('refresh_token')
}
